import GoogleSymbols from "@/components/icons/GoogleSymbols.vue";
import SVGLoader from "@/components/icons/SVGLoader.vue";
import DefaultButton from "@/components/buttons/DefaultButton.vue";
import DefaultSwitcher from "@/components/buttons/DefaultSwitcher.vue";
import AlertsChips from "@/components/utils/AlertsChips.vue";

export default {
  install(Vue) {
    Vue.component("google-icon", GoogleSymbols);
    Vue.component("svg-icon", SVGLoader);
    Vue.component("default-btn", DefaultButton);
    Vue.component("default-switcher", DefaultSwitcher);
    Vue.component("alerts-chips", AlertsChips);
  }
};
